export default __webpack_public_path__ + "static/media/6(Dutch-Bangla-Tower).62814444.jpg";